import { render, staticRenderFns } from "./LanguageList.vue?vue&type=template&id=856cbf94&scoped=true&"
import script from "./LanguageList.vue?vue&type=script&lang=js&"
export * from "./LanguageList.vue?vue&type=script&lang=js&"
import style0 from "./LanguageList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LanguageList.vue?vue&type=style&index=1&id=856cbf94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856cbf94",
  null
  
)

export default component.exports